import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

/** The spinning loader icon, for inline use (buttons, small blocks). */
export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden className={cn("size-6 animate-spin text-primary", className)} />;
}

/**
 * A spinner card in the middle of the screen, for page-level loads that take
 * seconds (e.g. Clicks over All time). Only the card is drawn: the page under
 * it stays visible and clickable, so the user can change the query meanwhile.
 */
export function LoadingOverlay({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-0 z-40 flex items-center justify-center"
    >
      <div className="flex items-center gap-3 rounded-xl border border-border bg-card/95 px-5 py-4 shadow-lg backdrop-blur-sm">
        <Spinner />
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
    </div>
  );
}
